import {useEffect, useRef} from "react";

const ESC_KEY = 27;

export function useOnClickOutside(closeFn) {
    const node = useRef();
    const handleClick = e => {
        const clickedInside = node.current.contains(e.target);
        if (clickedInside) return;
        closeFn(e.target);
    };
    const handleKeyDown = e => {
        const escapeKeyPressed = e.which === ESC_KEY;
        if (!escapeKeyPressed) return;
        closeFn(e.target);
    };
    useEffect(() => {
        // when [] is mounted
        document.addEventListener("mousedown", handleClick);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            // when [] is unmounted
            document.removeEventListener("mousedown", handleClick);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return node;
}
